<template>
    <div class="flight-details pt-80">
        <div class="container">
            <div class="header-list d-flex flex-wrap text-capitalize text-white">
                <span class="bg-dark font-13 px-15 py-5">Trip ID: {{ trip.id }}</span>
                <span class="bg-primary font-13 px-15 py-5">Planned Flight</span>
                <span v-if="tripIsAnEmptyLeg" class="bg-info font-13 px-15 py-5">Empty Leg</span>
                <span class="bg-light-blue font-13 font-13 px-15 py-5">{{ trip.hostRole }}</span>
            </div>
            <div class="box-shadow d-md-flex flex-wrap">
                <div class="description pl-30 pr- pt-25 pb-20">
                    <div class="flight-header d-flex flex-wrap border-bottom pb-28 mr-30">
                        <div class="from pl-13 pr-15">
                            <span class="title text-pearl d-block mb-3">From</span>
                            <span class="data-value d-block">{{trip.fliesFrom.fid}} - {{trip.fliesFrom.name}}</span>
                        </div>
                        <div class="to pl-13 pl-md-0">
                            <span class="title text-pearl d-block mb-3">To</span>
                            <span class="data-value d-block">{{trip.fliesTo.fid}} - {{trip.fliesTo.name}}</span>
                        </div>
                    </div>
                    <div class="flight-body d-flex flex-wrap mb-10">
                        <div class="body-wrapper px-15 pt-20 pb-18 mr-28">
                            <span class="title text-pearl d-block">Date</span>
                            <span
                                class="data-value d-block">{{ getFormattedDate(trip.typeFields.departureDate) }}</span>
                        </div>
                        <div class="body-wrapper px-15 pt-20 pb-18 mr-28">
                            <span class="title text-pearl d-block">Departure Time</span>
                            <span
                                class="data-value d-block">{{ getFormattedTime(trip.typeFields.departureTime) }}</span>
                        </div>
                        <div class="body-wrapper px-15 pt-20 pb-18 mr-28">
                            <span class="title text-pearl d-block">Estimated</span>
                            <span class="data-value d-block">{{ getEstimatedLabel() }}</span>
                        </div>
                        <div class="body-wrapper px-15 pt-20 pb-18 mr-28">
                            <span class="title text-pearl d-block">Distance</span>
                            <span class="data-value d-block">{{ trip.flightDistance }} miles</span>
                        </div>
                        <div class="body-wrapper px-15 pt-20 pb-18 mr-28">
                            <span class="title text-pearl d-block">Plane</span>
                            <span class="data-value d-block">{{ trip.typeFields.aircraft.name }} - {{ trip.typeFields.aircraft.seatsStandard }} Seats</span>
                        </div>
                        <div class="body-wrapper px-15 pt-20 pb-18 mr-28">
                            <span class="title text-pearl d-block">Seats available</span>
                            <span class="data-value d-block">{{ trip.capacity-trip.passengers }} </span>
                        </div>
                        <div class="body-wrapper px-15 pt-20 pb-18">
                            <span class="title text-pearl d-block">Seats taken</span>
                            <span class="data-value d-block">{{ trip.passengers }}</span>
                        </div>
                    </div>
                    <div v-if="trip.petsAllowed==0 && trip.minorsAllowed==0" class="text-center pl-10 pr-50">
                        <span class="title text-pearl">Restrictions:</span>
                        <span class="data-value"> No Pets, No Minors</span>
                    </div>
                    <div v-else-if="trip.petsAllowed==0" class="text-center pl-10 pr-50">
                        <span class="title text-pearl">Restrictions:</span>
                        <span class="data-value"> No Pets</span>
                    </div>
                    <div v-else-if="trip.minorsAllowed==0" class="text-center pl-10 pr-50">
                        <span class="title text-pearl">Restrictions:</span>
                        <span class="data-value"> No Minors</span>
                    </div>
                </div>
                <div class="estimation-cost text-center d-flex flex-column w-100">
                    <div v-if="!tripIsAnEmptyLeg"
                         class="total-cost d-flex flex-column align-items-center justify-content-center flex-grow-1 p-5">
                        <span class="font-20 text-primary">${{trip.price}}</span>
                        <span class="d-block">Flight Total Cost</span>
                    </div>
                    <div v-if="!tripIsAnEmptyLeg"
                         class="shared-estimated-cost bg-secondary d-flex flex-column align-items-center justify-content-center flex-grow-1 p-5">
                        <span class="font-20 text-primary">${{ getSharedEstimated(trip.price, trip.passengers) }}</span>
                        <span class="d-block">Shared Estimated</span>
                    </div>
                    <div v-if="tripIsAnEmptyLeg"
                         class="total-cost d-flex flex-column align-items-center justify-content-center flex-grow-1 p-5">
                        <span class="font-20 text-primary">Price Negotiable</span>
                    </div>
                    <join-flight
                        v-if="trip" 
                        :tripIsAnEmptyLeg="tripIsAnEmptyLeg" 
                        @joinFlight="newConversation" 
                        @goToChat="goToChat"
                        :tripId="trip.id"
                        @incomingMessage="sendMessage" 
                        @joinRequest="storeRequest"
                        :relationWithUser="trip.relationWithUser"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import JoinFlight from '../Cards/Components/JoinFlightButton';
    import TripCardMixin from '../../../mixins/tripCardMixin';

    export default {
        components: {
            JoinFlight,
        },
        mixins: [TripCardMixin],
        props: {
            trip: {
                type: Object
            },
        },
        data() {
            return {
                conversation: {}
            }
        },
        methods: {
            chatRouter() {
                this.$router.push({
                    name: 'MessageList',
                    params: {trip: this.trip.id},
                    query: {conversation: this.conversation.id}
                })
            }
        },
        computed: {
            tripIsAnEmptyLeg: function () {
                return this.trip.passengers == 0;
            }
        }
    }
</script>
